import React from 'react';
import _ from 'lodash';
import Select from 'react-select';
import CreatableSelect, { makeCreatableSelect } from 'react-select/creatable';
import InputGroupAddon from 'app/components/general/InputGroupAddon';

interface ISelectInputProps {
  className: string;
  icon: string;
  createable: boolean;
  isMulti: boolean;
  name: string;
  value: string;
  placeholder: string;
  autoFocus: string;
  onChange: any;
  clearable: boolean;
  disabled: boolean;
  options: string;
}
export default class SelectInput extends React.Component<ISelectInputProps, {}> {
  static defaultProps: ISelectInputProps = {
    className: undefined,
    icon: undefined,
    createable: false,
    isMulti: false,
    name: undefined,
    value: undefined,
    placeholder: undefined,
    autoFocus: undefined,
    onChange: undefined,
    clearable: false,
    disabled: false,
    options: undefined,
  };

  getOptionLabel = (e) => e.name || e.label

  getOptionValue = (e) => e.id || e.value

  render(): React.ReactNode {
    const value = !_.isEmpty(this.props.value) ? this.props.value : '';
    const className = this.props.icon
      ? `${this.props.className} with-icon`
      : this.props.className;
    if (this.props.createable) {
      return (
        <div className={this.props.icon ? 'with-icon' : null}>
          {this.props.icon ? <InputGroupAddon icon={this.props.icon} /> : null}
          <CreatableSelect
            name={this.props.name}
            id={this.props.name}
            value={value}
            getOptionLabel={this.getOptionLabel}
            getOptionValue={this.getOptionValue}
            isMulti={this.props.isMulti}
            placeholder={this.props.placeholder}
            aria-label={this.props.placeholder}
            autoFocus={this.props.autoFocus}
            onChange={(e) => this.props.onChange(e, this.props.name)}
            // onInputChange={(e) => this.props.onChange(e, this.props.name)}
            classNamePrefix="react-select"
            isDisabled={this.props.disabled || false}
            noOptionsMessage={() => 'No options, type to create one'}
            isClearable={this.props.clearable || false}
            options={this.props.options}
            className={className}
          />
        </div>
      );
    }
    return (
      <div className={this.props.icon ? 'with-icon' : null}>
        {this.props.icon ? <InputGroupAddon icon={this.props.icon} /> : null}
        <Select
          name={this.props.name}
          id={this.props.name}
          value={value}
          getOptionLabel={({ name }) => name}
          getOptionValue={({ id }) => id}
          isMulti={this.props.isMulti}
          placeholder={this.props.placeholder}
          aria-label={this.props.placeholder}
          autoFocus={this.props.autoFocus}
          onChange={(e) => this.props.onChange(e, this.props.name)}
          classNamePrefix="react-select"
          isDisabled={this.props.disabled || false}
          isClearable={this.props.clearable || false}
          options={this.props.options}
          className={className}
        />
      </div>
    );
  }
}
